import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class QtCategory {
    qtCategoryId: string
    nameEs: string
    nameEn: string
    namePt: string

    constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
        this.qtCategoryId = id
        this.nameEs = nameEs
        this.nameEn = nameEn
        this.namePt = namePt
    }

    static mapQtCategoryToSelectOption(self: QtCategory, language: AppLanguage): IUfinetSelectOption {      
        return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.qtCategoryId,
		}
    }
}